import React, { forwardRef } from 'react';
import { GetProps, InputRef } from 'antd';
import { MaskedInput as Input } from 'antd-mask-input';
import { StyledMaskedInput } from './InputStyles';

type TMaskedInputProps = GetProps<typeof Input>;

const MaskedInput = forwardRef<InputRef, TMaskedInputProps>((props, ref) => <StyledMaskedInput {...props} ref={ref} />);

MaskedInput.displayName = 'MaskedInput';

export default MaskedInput;
